module.exports = __webpack_public_path__ + "static/Portrait-of-Emil-min-79b835d2b28ee12711e88de1884dc8e4.webp";